import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { func, string, object } from "prop-types";
import { register, sendVerificationLink } from "@quintype/bridgekeeper-js";
import get from "lodash/get";
import { parseUrl } from "query-string";
import { Button } from "../../atoms/Button";
import { InputField } from "../../atoms/InputField";

import "./forms.m.css";

const SignUpBase = ({ onSignup, onLogin, qtConfig, currentPath, customCallbackUrl }) => {
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [errorMsg, setError] = useState("");
  const [verficationSuccessMessage, setSuccessMessage] = useState("");
  const [userExists, setUserExists] = useState(false);
  const [currentLocation, setCurrentLocation] = useState("/");
  const isVerificationLinkflow = get(qtConfig, ["publisher-attributes", "is_verification_link_flow"], true);
  const ssoLoginIsEnable = get(qtConfig, ["publisher-attributes", "sso_login", "is_enable"], false);
  const isSubscriptionUrl = typeof window !== 'undefined' && window.location.pathname === '/subscription';

  const signUpHandler = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!userInfo.name && !userInfo.email && !userInfo.password) {
      setError("Ole hyvä ja syötä nimesi, sähköpostiosoitteesi ja salasanasi");
      return;
    } else if (!userInfo.name) {
      setError("Ole hyvä ja syötä nimesi");
      return;
    } else if (!userInfo.email) {
      setError("Ole hyvä ja syötä sähköpostiosoitteesi");
      return;
    } else if (!userInfo.password) {
      setError("Ole hyvä ja syötä salasana");
      return;
    }

    const userObj = {
      name: userInfo.name,
      email: userInfo.email,
      username: userInfo.email,
      password: userInfo.password,
      "dont-login": true,
    };

    try {
      const { user, message } = await register(userObj);
      if (!user && message === "User Already exists") {
        return setUserExists(true);
      }

      if (isVerificationLinkflow) {
        const params = parseUrl(currentPath);
        const callbackUrl = ssoLoginIsEnable
          ? customCallbackUrl ||
            get(params, ["query", "callback_uri"]) ||
            get(qtConfig, ["publisher-attributes", "sso_login", "callback_Url"], "")
          : currentLocation;
        sendVerificationLink(userInfo.email, callbackUrl);
        !userExists &&
          setSuccessMessage(
            `Olemme lähettäneet aktivointisähköpostin osoitteeseen ${userInfo.email}. Tarkista sähköpostisi.`
          );
      } else {
        onSignup(user);
      }
    } catch (err) {
      if (err.status === 409) {
        setError(`Sähköpostiosoite '${userObj.email}' on jo käytössä.`);
      } else {
        setError("Hups! Jotain meni vikaan.");
      }
    }
  };

  const setData = (e) => {
    const userObj = { ...userInfo };
    const fieldName = e.target.id;
    userObj[fieldName] = e.target.value;
    setUserInfo(userObj);
  };

  const onVerify = () => {
    if (isVerificationLinkflow) {
      setSuccessMessage("Vahvistuslinkki on lähetetty uudelleen");
      return sendVerificationLink(userInfo.email, currentLocation);
    }

    return onSignup(userInfo);
  };

  const onResendVerification = () => {
    sendVerificationLink(userInfo.email, currentLocation);
    setSuccessMessage("Vahvistuslinkki on lähetetty uudelleen");
  };

  useEffect(() => {
    setCurrentLocation(window.location.href);
  }, []);

  const isUserLoginUrl = typeof window !== 'undefined' && window.location.pathname === '/user-login';

  return (
    <form styleName="malibu-form-signup" onSubmit={signUpHandler}>
      <InputField name="Nimi" id="name" required onChange={setData} />
      <InputField name="Sähköpostiosoite" type="email" id="email" onChange={setData} required />
      <InputField name="Salasana" type="password" id="password" onChange={setData} required />
      {!verficationSuccessMessage && userExists && (
        <p styleName="error">
          Sähköpostiosoite on jo rekisteröity. Ole hyvä ja <button onClick={onVerify}>vahvista</button> tai <button onClick={onLogin}>kirjaudu sisään</button>.
        </p>
      )}
      {errorMsg && <p styleName="error">{errorMsg}</p>}
      <div styleName="signup-button-wrapper">
        <button aria-label="signup-button" onClick={signUpHandler} styleName="malibu-btn-large-2" style={{fontWeight: 600, ...(isUserLoginUrl ? { marginBottom: '20px'} : {})}}>
          Rekisteröidy
        </button>
      </div>
      {verficationSuccessMessage && (
        <>
          <p styleName="message-text" style={{paddingBottom: "5px", ...(isSubscriptionUrl ? {marginTop: "10px", marginBottom: "0px"} : {})}}>
            {verficationSuccessMessage} Jos et ole saanut vahvistuslinkkiä, paina{" "}
            <button aria-label="button-resend" onClick={onResendVerification}>
              lähetä uudelleen
            </button>{" "}
          </p>
        </>
      )}
    </form>
  );
};

SignUpBase.propTypes = {
  onSignup: func,
  setMember: func,
  onLogin: func,
  qtConfig: object,
  currentPath: string,
  customCallbackUrl: string,
};

const mapStateToProps = (state) => ({
  qtConfig: get(state, ["qt", "config"], {}),
  currentPath: get(state, ["qt", "currentPath"], ""),
});

export const SignUp = connect(mapStateToProps, null)(SignUpBase);
